import styled from 'styled-components';
import { themeGet } from '../../../foundation/theme/themeGet/get.js';

var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-fhoa8q-0"
})(["display:flex;flex-direction:row;justify-content:flex-start;align-items:center;gap:", ";"], themeGet('spacing.lg'));

export { Container };
